module.exports = __webpack_public_path__ + "img/支撑型悬臂箱.8cbe167d.jpg";